import React from 'react';

interface UploadProgressProps {
  uploadProgress: number;
}

export const UploadProgress = ({ uploadProgress }: UploadProgressProps) => {
  return (
    <div className="w-full space-y-4">
      <div className="flex items-center justify-center">
        <div className="w-12 h-12 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className="bg-primary h-2 rounded-full transition-all duration-300"
          style={{ width: `${uploadProgress}%` }}
        />
      </div>
      <p className="text-center text-sm text-gray-600">
        Uploading... {uploadProgress}%
      </p>
    </div>
  );
};